import Vue from 'vue'
import Vuex from 'vuex'
import geojson from './modules/geojson';


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    geojson
  }
})
